import React, { useState, useEffect } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Heading,
  Loading,
  RadioButton
} from 'components/common/Elements/Elements';
import Chart from './Chart';
import { Legend, Trend } from 'components/common/charts/parts/parts';

import {
  monthPerLabel,
  monthesPeriods
} from 'components/common/charts/helpers/config/filtersConfig';
import { calcTrend } from 'utils/common';
import useWindowSize from 'hooks/useWindowSize';

import classes from './Chart.module.scss';

const ComposedAL = ({ config, data }) => {
  const [period, setPeriod] = useState('6M');
  const [conf, setConf] = useState(config.config);

  const [show, setShow] = useState(true);
  const [oldSize, setOldSize] = useState(0);

  const size = useWindowSize();

  useEffect(() => {
    let timer = null;
    if (oldSize > size.width || (size.width >= 1441 && oldSize < 1441)) {
      setShow(false);
      setOldSize(size.width);
      timer = setTimeout(() => setShow(true), 500);
    } else setOldSize(size.width);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [size.width]);

  const trend =
    data && data.length >= 2
      ? calcTrend(
          data[data.length - 1][config.trendKey],
          data[data.length - 2][config.trendKey],
          2
        )
      : ' - Not enough data to trend calculation';

  const toCut = () => {
    //lengs of period
    if (period === '6M') {
      return 6;
    } else if (period === '3M') {
      return 3;
    } else {
      return 2;
    }
  };

  const formatDate = //cut date with get period
    period !== '1Y'
      ? data.slice(Math.max(data.length - toCut(), 0))
      : [...data];

  const handlePeriod = e => {
    if (e.target.value !== period) {
      setPeriod(e.target.value);
    }
  };

  return (
    <section className={classes.box}>
      <div className={classes.info}>
        <div className={classes.header}>
          <Heading>{config.title}</Heading>
          <Trend trend={trend} />
        </div>
        <RadioButton
          handleUnit={handlePeriod}
          unit={period}
          units={monthesPeriods}
          name="Period"
          type="c"
          unitsLabel={monthPerLabel}
        />
      </div>
      {show ? <Chart data={formatDate} config={conf} /> : <Loading />}
      <Legend config={conf} setConfig={setConf} />
    </section>
  );
};

ComposedAL.propTypes = {
  data: PropTypes.arrayOf(object),
  config: PropTypes.shape({
    config: PropTypes.arrayOf(object),
    trendKey: PropTypes.string,
    title: PropTypes.string
  }).isRequired
};

export default ComposedAL;
